/**
 * Schreiben-Entwurf im Portal-Chat: Platzhalter, Export-Text, Dateinamen.
 * Quelle für PDF (Gotenberg) und DOCX (blankDocx + Upload) ist der sichtbare Chat-Text.
 */

const SCHREIBEN_DRAFT_FOOTER_RE = /\[\s*Entwurf[^\]]*\]/gi;
const SCHREIBEN_STAMP_RE = /\[(?:LEX|JUD):[^\]]+\]/gi;
const BRACKET_PLACEHOLDER_RE = /\[[^\]]+\]/;

/** Entwurfs-Fußnote auf die kurze Prüf-Zeile kürzen — Platzhalter [Name] usw. bleiben. */
export function sanitizeSchreibenExportText(text: string): string {
  return String(text || '')
    .replace(SCHREIBEN_DRAFT_FOOTER_RE, '[Entwurf \u2013 anwaltlich zu pruefen]')
    .replace(/\s{3,}/g, '\n\n')
    .trim();
}

/**
 * Unausgefüllte eckige Klammern (ohne Entwurfs-Fußnote und ohne LEX/JUD-Stempel).
 * z. B. [Name des Mandanten], [Datum], [Anschrift].
 */
export function hasUnfilledSchreibenPlaceholders(text: string): boolean {
  const stripped = String(text || '')
    .replace(SCHREIBEN_DRAFT_FOOTER_RE, '')
    .replace(SCHREIBEN_STAMP_RE, '');
  return BRACKET_PLACEHOLDER_RE.test(stripped);
}

export function schreibenExportDisplayName(ext: 'pdf' | 'docx', now = new Date()): string {
  const day = now.toISOString().slice(0, 10);
  return `Schreiben (${day}).${ext}`;
}

export function portalDocumentKindLabel(displayName: string): 'PDF' | 'DOCX' | 'Datei' {
  const lower = String(displayName || '').toLowerCase();
  if (lower.endsWith('.pdf')) return 'PDF';
  if (lower.endsWith('.docx') || lower.endsWith('.doc')) return 'DOCX';
  return 'Datei';
}
